import React from "react";

const asyncComponent = (importComponent) => {
  return class extends React.Component {
    state = {
      component: null,
    };

    componentDidMount() {
      importComponent()
        .then((cpm) => {
          this.setState({ component: cpm.default });
        })
        .catch((err) => {
          console.log(
            "asynccomponent/index.js === componentDidMount == component import error = ",
            { err }
          );
        });
    }

    render() {
      const C = this.state.component;
      return C ? <C {...this.props} /> : null;
    }
  };
};

export default asyncComponent;
